/**
 * STAGING-ONLY listening pods carried in code, not in the database (job #360).
 *
 * Tom, 2026-11-02: "all I need is to have these live in Staging on the Italian
 * course and I'll have a good listen to them". Talk Bollocks Part 1 in Italian
 * (#983 render, #323 check: 32 clips corrected) has never been live to
 * learners. Its clips are TRIAL clips (`trial_<UUID>`, S3 `trial/`), which by
 * Tom's #748 rule are never filed against a live course, so the pod cannot be
 * a `listening_pods` row. It rides here instead and is appended to Listening
 * Mode's pod list for `ita_for_eng` ONLY when the page is served from the
 * staging host. Production code is the same code after Friday's promotion, so
 * the gate is the HOSTNAME, checked at run time, and fails closed: any other
 * host, including saysomethingin.app, gets nothing. The audio proxy repeats the
 * gate on its side (api/_utils/stagingTrialClips.ts), so the clips themselves
 * answer 404 off staging.
 *
 * Removing it is deleting this file, its data file and the one call site in
 * useListeningPods.
 */
import { TALK_BOLLOCKS_ITA_1_ROWS, TALK_BOLLOCKS_ITA_1_SCENE_NAMES } from './talkBollocksIta1.data'

/** The only host these pods are served on. */
export const STAGING_POD_HOSTS = ['staging.saysomethingin.app'] as const

export interface StagingPod {
  podId: string
  slug: string
  title: string
  rows: typeof TALK_BOLLOCKS_ITA_1_ROWS
  sceneNames: Record<string, string>
}

const PODS: Record<string, StagingPod[]> = {
  ita_for_eng: [
    {
      podId: 'ita_for_eng:talk-bollocks-1',
      slug: 'talk-bollocks-1',
      title: 'Tom and Aran Talk Bollocks — Part 1',
      rows: TALK_BOLLOCKS_ITA_1_ROWS,
      sceneNames: TALK_BOLLOCKS_ITA_1_SCENE_NAMES,
    },
  ],
}

/** The staging-only pods for this course on this host; [] anywhere else. */
export const stagingPodsFor = (courseCode: string, hostname: string | null | undefined): StagingPod[] =>
  hostname && (STAGING_POD_HOSTS as readonly string[]).includes(hostname) ? PODS[courseCode] ?? [] : []

/** The current page's hostname, or null outside a browser. */
export const currentHostname = (): string | null =>
  typeof window !== 'undefined' && window.location ? window.location.hostname : null
